import { render, staticRenderFns } from "./Specimen.vue?vue&type=template&id=deaead7c&scoped=true&"
import script from "./Specimen.vue?vue&type=script&lang=js&"
export * from "./Specimen.vue?vue&type=script&lang=js&"
import style0 from "./Specimen.vue?vue&type=style&index=0&id=deaead7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deaead7c",
  null
  
)

export default component.exports